import { useToggle } from 'ahooks';
import { Button, Space, Tooltip } from 'antd';
import { FC, lazy, Suspense, useEffect, useState } from 'react';

import { IpBtn } from './helper';
const BindIpModal = lazy(() => import('./comps/BindIpModal'));

const getShowIp = (ips: string) => {
  if (ips === '*') {
    return '--';
  }
  const ipArray = ips?.split(',') || [];
  let result: any = ips;
  if (ipArray.length > 3) {
    result = (
      <Tooltip
        title={ips}
        overlayInnerStyle={{ padding: '9px 12px' }}
        overlayStyle={{ maxWidth: 300 }}
      >
        {ipArray.slice(0, 3)?.toString()}...
      </Tooltip>
    );
  }
  return result;
};
export const BindIpBtn: FC<IpBtn> = ({
  selectedApis,
  ips,
  apiKey,
  hasGoogle2fa,
  updateIps,
  subAccountId,
  isFromSubAccount,
  disabled,
}) => {
  const [showUpdateIpsModal, { toggle }] = useToggle(false);
  const [loadBindIpModal, setLoadBindIpModal] = useState(false);

  useEffect(() => {
    if (showUpdateIpsModal) {
      setLoadBindIpModal(true);
    }
  }, [showUpdateIpsModal]);

  const openModal = () => {
    if (!hasGoogle2fa()) {
      return;
    }
    toggle();
  };
  return (
    <>
      <Space size={8} style={{ maxWidth: 400 }}>
        {getShowIp(ips)}
        <Button
          type="link"
          onClick={openModal}
          disabled={disabled}
          style={{ width: 16 }}
          icon={
            <i className="byIcon icon-fi_edit" style={{ color: '#81858C' }} />
          }
        ></Button>
      </Space>

      <Suspense fallback="">
        {loadBindIpModal && (
          <BindIpModal
            selectedApis={selectedApis}
            subAccountId={subAccountId as string}
            isFromSubAccount={isFromSubAccount}
            ips={ips === '*' ? '' : ips}
            apiKey={apiKey}
            onOk={updateIps}
            onCancel={toggle}
            isVisible={showUpdateIpsModal}
          />
        )}
      </Suspense>
    </>
  );
};
